import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=c24b7e7a&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c24b7e7a')) {
      api.createRecord('c24b7e7a', component.options)
    } else {
      api.reload('c24b7e7a', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=c24b7e7a&", function () {
      api.rerender('c24b7e7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dXnwG13M0xhJ/JS/comp/ImageCarousel.vue"
export default component.exports